/**
 * 学习乐园 · 连连看题材包：拼音识字（lianliankan/pack-pinyin.js）
 * ---------------------------------------------------------------------------
 * 关联型配对：带调拼音连汉字（「shān」连「山」）。选字全是小学低年级
 * 高频字，音形都日常；配错反馈直接说「『mǎ』的正确搭档是『马』」，
 * 不需要额外 note——牌面本身就是答案。
 */
(function (global) {
  'use strict';
  var PACKS = global.STLLK_PACKS = global.STLLK_PACKS || {};

  PACKS.pinyin = {
    id: 'pinyin',
    name: '拼音识字',
    hint: '带调拼音连汉字',
    kind: 'rel',
    cols: 6,
    rows: 6,
    pairs: [
      { l: 'rén',  r: '人' },
      { l: 'kǒu',  r: '口' },
      { l: 'mù',   r: '木' },
      { l: 'shuǐ', r: '水' },
      { l: 'huǒ',  r: '火' },
      { l: 'shān', r: '山' },
      { l: 'tián', r: '田' },
      { l: 'rì',   r: '日' },
      { l: 'yuè',  r: '月' },
      { l: 'mǎ',   r: '马' },
      { l: 'niǎo', r: '鸟' },
      { l: 'yú',   r: '鱼' },
      { l: 'chē',  r: '车' },
      { l: 'mén',  r: '门' },
      { l: 'huā',  r: '花' },
      { l: 'cǎo',  r: '草' },
      { l: 'fēi',  r: '飞' },
      { l: 'zǒu',  r: '走' },
      { l: 'chī',  r: '吃' },
      { l: 'hē',   r: '喝' },
      { l: 'dà',   r: '大' },
      { l: 'xiǎo', r: '小' },
      { l: 'duō',  r: '多' },
      { l: 'shǎo', r: '少' },
      { l: 'tiān', r: '天' },
      { l: 'dì',   r: '地' },
      { l: 'fēng', r: '风' },
      { l: 'yǔ',   r: '雨' }
    ]
  };
})(typeof window !== 'undefined' ? window : globalThis);
